import { PaginatedEntity } from '@core/entities';
import { Expose, Type } from 'class-transformer';
import { SafeUrl } from '@angular/platform-browser';

export class UserContentNewsList extends PaginatedEntity {
  @Type(() => UserContentNewsEntity)
  news: UserContentNewsEntity[];
}

export class UserContentNewsEntity {
  id: number;
  title: string;
  @Expose({ name: 'text' })
  description: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  date: string;

  // For Ui use only
  imageUrl: string | SafeUrl;
}
